import { createTheme } from '@mui/material/styles';

//Listing Onboarding Theme
const theme = createTheme({
  typography: {
    fontFamily: 'Inter, sans-serif',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        'html, body': {
          margin: 0,
          padding: 0,
          height: '100%',
          overflow: 'hidden'
        },
        '#root': {
          height: '100%',
        },
        'ol, ul': {
          fontFamily: 'Inter, sans-serif',
        },
        'li': {
          fontFamily: 'Inter, sans-serif',
        }
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
            borderRadius: '30px',
            backgroundColor: 'none',
            border: '1px solid black',
            color: 'black',
          },
          borderRadius: '30px',
          '&.Mui-selected': {
            backgroundColor: 'black',
            color: 'white',
            '&:hover': {
              backgroundColor: 'black',
              borderRadius: '30px',
            }
          },
        },
      },
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: 'black',
            '& .MuiBottomNavigationAction-label': {
              color: 'black',
              fontWeight: 600,
            },
          },
          '& .MuiBottomNavigationAction-label': {
            color: '#757575',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            boxShadow: 'none',
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'black',
            },
            borderRadius: '8px', // Add this line for rounded corners
            '& .MuiOutlinedInput-notchedOutline': {
              borderRadius: '8px', // Add this line for the border outline
            },
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: 'black',
          },
          // Hide number input spinners
          '& input[type=number]': {
            '-moz-appearance': 'textfield',
            '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
              '-webkit-appearance': 'none',
              margin: 0,
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'black',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'black',
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          '& .MuiInputLabel-root.Mui-focused': {
            color: 'black',
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: 'black',
          },
          // Optional: change the color of the radio button when unchecked
          color: '#757575',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: 'black',
          },
          // Optional: change the color of the radio button when unchecked
          color: '#757575',
        },
      },
    },
    // Add styling for Switch component
    MuiSwitch: {
      styleOverrides: {
        root: {
          '& .MuiSwitch-switchBase.Mui-checked': {
            color: 'black',
            '& + .MuiSwitch-track': {
              backgroundColor: 'black',
              opacity: 0.5,
            },
          },
        },
      },
    },
    // Add styling for "Add Time Range" button text
    MuiButtonBase: {
      styleOverrides: {
        root: {
          '&.MuiButton-root': {
            '&[aria-label="add-time-range"]': {
              color: 'black',
            },
          },
        },
      },
    },
  },
});

export default theme;